module.exports = __webpack_public_path__ + "img/erp-logos_0022_pronto.8b4f16d5.jpg";